import React from 'react';
import { func, oneOf } from 'prop-types';
import { Icons } from 'components';
import { noop } from 'utils';

const SLIDE_DIRECTIONS = {
    PREVIOUS: 'previous',
    NEXT: 'next',
};

const InCategorySearchListControl = ({ direction, onClick }) => {
    const interactionHandler = () => onClick(direction);
    return (
        <button
            className={`intra-category__control intra-category__control--${direction}`}
            onClick={interactionHandler}
        >
            <span className="intra-category__control__wrapper">
                {direction === SLIDE_DIRECTIONS.PREVIOUS ? (
                    <Icons.ChevronLeft className="intra-category__control__icon" />
                ) : (
                    <Icons.ChevronRight className="intra-category__control__icon" />
                )}
            </span>
        </button>
    );
};

InCategorySearchListControl.propTypes = {
    direction: oneOf(Object.values(SLIDE_DIRECTIONS)).isRequired,
    onClick: func,
};

InCategorySearchListControl.defaultProps = {
    onClick: noop,
};

export default InCategorySearchListControl;
export { SLIDE_DIRECTIONS };
